import { Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { Fragment } from 'react'
import { conceptualFrameworkItems } from '../ducks/context/index.js'
import { assessmentItemType, observationRole } from '../ducks/learnableMoments/index.js'

const styles = makeStyles({
  title: {
    fontSize: '1rem',
    fontWeight: 'bold',
    marginTop: '1rem',
  },
  groupTitle: {
    fontSize: '.9rem',
    fontWeight: 'bold',
    marginTop: '.5rem',
    marginBottom: '.3rem',
  }
})

const addAnswersToItem = (answers, checklistItem) => {
  const result = {
    ...checklistItem,
    groups: checklistItem.groups.map(group => ({
      ...group,
      items: group.items.map(item => ({
        ...item,
        check: !!answers.find(answer => answer.property === item.id)
      }))
    }))
  }
  result.groups.filter(group => !group.noPoints).forEach(group => group.score = group.items.reduce((carry, curr) => carry + (curr.check ? curr.points : 0), 0))
  result.score = result.groups.reduce((carry, curr) => carry + (curr.score || 0), 0)
  return result
}

const Checklist = ({learnableMoment, submissions}) => {
  const classes = styles()

  const checklistItem = learnableMoment.assessmentItems.find(item => item.type === assessmentItemType.CHECKLIST)

  if (!checklistItem) {
    return null
  }

  const checklistConfig = conceptualFrameworkItems.find(i => i.id === checklistItem.id)
  const tutorAnswers = submissions[observationRole.TUTOR]?.[0]?.answers || []
  const checklistResult = addAnswersToItem(tutorAnswers, checklistConfig)

  const groups = checklistResult.groups.map(group => {
    const items = group.items.map(item =>
      <Typography key={item.id} variant='body2'>{item.check ? '✔' : '✖'} {item.title}</Typography>
    )
    return <Fragment key={group.id}>
      <Typography variant='h4' className={classes.groupTitle}>{group.title}{group.score !== undefined ? `: ${group.score} Punkt(e)` : ''}</Typography>
      { items }
    </Fragment>
  })

  return <>
    <Typography key={checklistItem.id} variant='h3' className={classes.title}>{checklistItem.title}: {checklistResult.score} Punkt(e)</Typography>
    <Grid container>
      <Grid item>
        { groups }
      </Grid>
    </Grid>
    <br/>
  </>
}


export default Checklist